import type { OfficeListItemAttribute } from "./types/office-list-item";

function getOfficeAttributeValue(
  attributes: OfficeListItemAttribute[] | undefined,
  typeName: string,
): string | undefined {
  const attribute = attributes?.find((item) => item.typeName === typeName);
  const value = attribute?.value;
  if (value == null || value === "") {
    return undefined;
  }
  return value;
}

function getOfficeNumericAttribute(
  attributes: OfficeListItemAttribute[] | undefined,
  typeName: string,
): number | null {
  const raw = getOfficeAttributeValue(attributes, typeName);
  if (raw == null) {
    return null;
  }
  const numericValue = Number(raw);
  return Number.isFinite(numericValue) ? numericValue : null;
}

function getOfficeCoordinatesFromAttributes(
  attributes: OfficeListItemAttribute[] | undefined,
): { latitude: number; longitude: number } | null {
  const latitude = getOfficeNumericAttribute(attributes, "Latitude");
  const longitude = getOfficeNumericAttribute(attributes, "Longitude");
  if (latitude == null || longitude == null) {
    return null;
  }
  return { latitude, longitude };
}

export {
  getOfficeAttributeValue,
  getOfficeCoordinatesFromAttributes,
  getOfficeNumericAttribute,
};
